import React from 'react'
import Button from '../../elements/button/Button'
import { ReactComponent as UnderSVG } from '../../../lib/assets/under.svg'
import { ReactComponent as OverSVG } from '../../../lib/assets/over.svg'
import { ROLL_PROPS } from './interface'
import { red, blue } from '../helpers/gradients'

function RollButton({ handleRollUnder, rollUnder, startAuto }: ROLL_PROPS) {
  return (
    <Button
      size='20px'
      background={rollUnder ? red : blue}
      childMargin={'0 6px 0 10px'}
      shadow={
        rollUnder ? 'inset 0px -3px 0px #DB2D2D' : 'inset 0px 3px 0px #1B3394'
      }
      font='Regular'
      func={() => handleRollUnder()}
      startAuto={startAuto}
    >
      {rollUnder ? <UnderSVG /> : <OverSVG />}
      <p>Roll {rollUnder ? 'under' : 'over'}</p>
    </Button>
  )
}

export default RollButton
